import React from 'react'

import { Box, ThemeProvider } from '@material-ui/core'

import { TopBar } from './components'
import { ScreenLoading } from 'layouts/Main/components'

import useCustomTheme from 'hooks/useCustomTheme'
import useAuthSupplier from 'hooks/useAuthSupplier'

import useStyles from './styles'

const SuppliersMainLayout = ({ children }) => {
  const classes = useStyles()
  const { customTheme } = useCustomTheme()
  const { loaded } = useAuthSupplier()

  return (
    <ThemeProvider theme={customTheme}>
      <ScreenLoading loaded={loaded}>
        <Box className={classes.root}>
          <TopBar />
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box className={classes.content} width="100%" height="100%">
              {children}
            </Box>
          </Box>
        </Box>
      </ScreenLoading>
    </ThemeProvider>
  )
}

export default SuppliersMainLayout
